import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { Icon, iconMap, IconName } from "./Icons";

interface LinkProps
	extends NextLinkProps,
		Omit<ComponentProps<"a">, keyof NextLinkProps> {
	title: string;
	icon?: IconName;
	disabled?: boolean;
	children?: React.ReactNode;
	className?: string;
}

export const Link = ({
	title,
	icon,
	disabled,
	children,
	className,
	...props
}: LinkProps) => {
	return (
		<NextLink
			className={cn(
				"flex min-h-12 flex-row items-center justify-between gap-4 rounded-xl border border-gray-300 px-2 py-2 transition-all duration-200",
				disabled && "opacity-50 pointer-events-none",
				className
			)}
			{...props}
		>
			{icon && (
				<div className="bg-yellow-200 rounded-lg p-2">
					{icon in iconMap ? (
						<Icon iconId={icon as IconName} color="yellow" />
					) : (
						<span className="text-yellow-400">{icon}</span>
					)}
				</div>
			)}
			<div className="text-lg text-left flex flex-col gap-2 mr-auto">
				{children || title}
			</div>
			<Icon iconId="IconChevronRight" className="w-6 h-6 shrink-0" />
		</NextLink>
	);
};
